<template>
  <WrapperFormElements
    :label
    :required
    :hint
    :alertLabel
    :alertType
    :help
  >
    <BasicInput
      v-model="modelValue"
      :disabled
      :size
      :validation-state
      :placeholder
      :maxlength
      :icon-state
      :icon-name
      :deletable
      :readonly
      :input-type
      :alertLabel
      :alertType
      :read-only-reason="props.readOnlyReason"
    />
  </WrapperFormElements>
</template>

<script setup lang="ts">
  import type { InputModel, WrapperInputProps, AlertInputProps } from '@designSystem/components'

  const props = withDefaults(defineProps<WrapperInputProps & AlertInputProps>(), {
    hasBg: true,
    wrap: false,
    hasLabel: true,
    maxLength: undefined,
    alertType: undefined,
    alertLabel: undefined,
  })

  const modelValue = defineModel<InputModel>()
</script>
